// extracted by mini-css-extract-plugin
module.exports = {"noResults":"styles_noResults__1mRVE"};